export default "__VITE_ASSET__lniEyPUG__"